import React, { useState, useCallback, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextInput from './Chatbot/Forms/TextInput';
import Card from '@material-ui/core/Card';
import SendIcon from '@material-ui/icons/Send';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';

const WEBHOOK_URL = process.env.REACT_APP_WEBHOOK_URL;

const Contact = ({ language }) => {
	const [ description, setDescription ] = useState('');
	const [ email, setEmail ] = useState('');
	const [ name, setName ] = useState('');

	// Functions triggered by inputting text value
	const inputDescription = useCallback(
		(event) => {
			setDescription(event.target.value);
		},
		[ setDescription ]
	);

	const inputEmail = useCallback(
		(event) => {
			setEmail(event.target.value);
		},
		[ setEmail ]
	);

	const inputName = useCallback(
		(event) => {
			setName(event.target.value);
		},
		[ setName ]
	);

	const validateEmailFormat = (email) => {
		const regex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
		return regex.test(email);
	};

	const validateRequiredInput = (...args) => {
		let isBlank = false;
		for (let i = 0; i < args.length; i = (i + 1) | 0) {
			if (args[i] === '') {
				isBlank = true;
			}
		}
		return isBlank;
	};

	// Slackに問い合わせがあったことを通知する
	const submitForm = () => {
		const isBlank = validateRequiredInput(name, email, description);
		const isValidEmail = validateEmailFormat(email);

		if (isBlank) {
			alert('Please fill all forms.');
			return false;
		} else if (!isValidEmail) {
			alert('Email address is invalid.');
			return false;
		} else {
			const payload = {
				text:
					'お問い合わせがありました\n' + 'お名前: ' + name + '\n' + 'メールアドレス: ' + email + '\n' + '【問い合わせ内容】\n' + description
			};

			// fetchメソッドでフォームの内容をSlackのIncoming Webhook URL に送信する
			fetch(WEBHOOK_URL, {
				method: 'POST',
				body: JSON.stringify(payload)
			}).then(() => {
				setOpen(true);
				setDescription('');
				setEmail('');
				setName('');
			});
		}
	};
	const [ open, setOpen ] = React.useState(false);

	const handleClose = (e, reason) => {
		if (reason === 'clickaway') {
			return;
		}

		setOpen(false);
	};
	const snackBar = (
		<div>
			<Snackbar
				open={open}
				autoHideDuration={6000}
				onClose={handleClose}
				anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
			>
				<Alert onClose={handleClose} severity="success" style={{ fontSize: 'large' }}>
					送信が完了しました。追ってご連絡いたします🙌
				</Alert>
			</Snackbar>
		</div>
	);

	const labelName = { en: 'Name (*required)', ja: 'お名前(必須)' };
	const labelEmail = { en: 'Email (*required)', ja: 'メールアドレス(必須)' };
	const labelContent = { en: 'Content (*required)', ja: 'お問い合わせ内容' };
	const buttonSend = { en: 'Send', ja: '送信' };
	const formTitle = { en: 'Get in touch', ja: 'お問い合わせ' };
	return (
		<div style={{paddingTop:'10rem'}}>
			<Card style={{ padding: '50px', width: '80%', margin: '6rem auto' }}>
				<h1 className="text-center">
					{' '}
					<FontAwesomeIcon icon={faEnvelope} /> <br />
					{language === 'English' ? formTitle.en : formTitle.ja}
				</h1>
				<form>
					<TextInput
						label={language === 'English' ? labelName.en : labelName.ja}
						multiline={false}
						rows={1}
						value={name}
						type={'text'}
						onChange={inputName}
					/>
					<TextInput
						label={language === 'English' ? labelEmail.en : labelEmail.ja}
						multiline={false}
						rows={1}
						value={email}
						type={'text'}
						onChange={inputEmail}
					/>

					<TextInput
						label={language === 'English' ? labelContent.en : labelContent.ja}
						multiline={true}
						rows={5}
						value={description}
						type={'text'}
						onChange={inputDescription}
					/>
				</form>
				<div className="float-right">
					<Button onClick={submitForm} color="secondary">
						<SendIcon style={{ fontSize: 'x-large' }} />
						<span style={{ fontSize: 'x-large', marginLeft: '1rem' }}>
							{language === 'English' ? buttonSend.en : buttonSend.ja}
						</span>
					</Button>
				</div>
			</Card>
			{snackBar}
		</div>
	);
};

export default Contact;
